<ngx-spinner size = "default" color = "#2197c3" type = "ball-clip-rotate" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<router-outlet (window:beforeunload)="doBeforeUnload()"></router-outlet>
